// extracted by mini-css-extract-plugin
export const root = "image-composition-module--root--1Zxw4";
export const image = "image-composition-module--image--2h1kQ";
export const small = "image-composition-module--small--EnaK7";
export const medium = "image-composition-module--medium--rA4p9";
export const large = "image-composition-module--large--GWnuC";
export const caption = "image-composition-module--caption--2D6W1";